import type { Resource } from '../../';
export const product_sizeChart_hideMoreCountries: Resource = {"default":"Hide"};
